import React from "react";
import "../../../css/YearRide.css";
import mobility from "../../../img/ride.png";

interface YearRideProps {
  YearRide: number;
}

const YearRide = ({ YearRide }: YearRideProps) => {
  return (
    <div className="year_ride_container">
      <div className="year_ride_display">
        <img className="mobility" src={mobility} />
        <div className="year_ride_title">今期の乗車金額</div>
      </div>
      <div className="year_ride_of">
        {YearRide.toLocaleString()}
        <span className="unit">円</span>
      </div>
    </div>
  );
};

export default YearRide;
